export const ENVIRONMENT_NAMES = {
    PRODUCTION: 'production',
    TEST_NEXT: 'test-next',
    TEST_CURRENT: 'test-current',
    UAT_NEXT: 'uat-next',
    UAT_CURRENT: 'uat-current'
};
